import type { Category, CategoryType } from '../data/types';

/**
 * resolve_review raises "This item is already resolved" when the item was filed
 * by an earlier tap or by a remembered payee. The owner's intent is already met,
 * so the client treats it as done, not as a failure.
 */
export function isAlreadyResolved(message: string): boolean {
  return /\bthis item is already (resolved|dismissed)\b/i.test(message);
}

/** Tidy a typed category name: single spaces, no edge whitespace, at most 40 characters. */
export function cleanCategoryName(input: string): string {
  return input.replace(/\s+/g, ' ').trim().slice(0, 40).trim();
}

/** Compare names ignoring case, spacing, punctuation and "and" vs "&". */
function nameKey(name: string): string {
  return name.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '');
}

/**
 * An existing active category the typed name already means, so "funeral" or
 * "giving and support" picks the one that exists instead of adding a near-duplicate.
 */
export function matchCategory(input: string, categories: Category[]): Category | undefined {
  const key = nameKey(cleanCategoryName(input));
  if (!key) return undefined;
  return categories.find((c) => c.is_active && nameKey(c.name) === key);
}

/** A new category typed while filing counts as lifestyle spending for money out, and as other for money in. */
export function customCategoryType(direction: 'debit' | 'credit'): CategoryType {
  return direction === 'credit' ? 'other' : 'lifestyle';
}
